import { render, staticRenderFns } from "./TasklistOverview.vue?vue&type=template&id=9cc73f98&scoped=true"
import script from "./TasklistOverview.vue?vue&type=script&lang=js"
export * from "./TasklistOverview.vue?vue&type=script&lang=js"
import style0 from "./TasklistOverview.vue?vue&type=style&index=0&id=9cc73f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc73f98",
  null
  
)

export default component.exports